<template lang="pug">
div
  v-layout(align-center)
    img(src='/images/email-logo.jpg', height='50')
    h3 Versturen per mail

  v-divider.mt-4.mb-4

  p DealerFinanceServices zal de binnenkomende aanvragen als PDF naar onderstaand email adres sturen.

  v-layout.mt-4.flex-column-phone
    text-field(
      label='Naam',
      v-model='data.name',
      required,
      :error-messages='nameValidationErrors',
      @change='$v.data.name.$touch()',
      @blur='$v.data.name.$touch()'
      )

    text-field(
      label='Email adres',
      v-model='data.email',
      required,
      :error-messages='emailValidationErrors',
      @change='$v.data.email.$touch()',
      @blur='$v.data.email.$touch()'
      )
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  props: {
    value: Object
  },

  data () {
    return {
      data: Object.assign({}, this.value)
    }
  },

  computed: {
    nameValidationErrors () {
      const errors = []
      if (!this.$v.data.name.$dirty) return errors
      !this.$v.data.name.required && errors.push('Dit veld is verplicht')
      return errors
    },

    emailValidationErrors () {
      const errors = []
      if (!this.$v.data.email.$dirty) return errors
      !this.$v.data.email.required && errors.push('Dit veld is verplicht')
      !this.$v.data.email.email && errors.push('Dit moet een geldig email adres zijn')
      return errors
    }
  },

  watch: {
    data: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    },

    '$v.$invalid': {
      handler: function (v) {
        this.$emit('valid', !v)
      },
      immediate: true
    }
  },

  validations: {
    data: {
      name: {
        required
      },

      email: {
        required,
        email
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
